let previousPath = ''

export default {
  methods: {
    // _ at the beginning of the method name because it's mixin
    _goBack(path = previousPath, query) {
      this.$router.push({ path, query })
      previousPath = ''
    },
  },
  beforeRouteEnter(to, from, next) {
    previousPath = previousPath || from.path
    next()
  },
}
